import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import LinkIcon from '@mui/icons-material/Link';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Tooltip from '@mui/material/Tooltip';
import {
  PROFESSIONAL_PLAN_NAME,
  planAvailabilityText,
} from '../../../../components/subscription/planLockTexts';

/**
 * PageHeader - Header section with title, subtitle and action button
 * @param {Object} props
 * @param {Function} props.onNewPatient - Callback to open new patient popup
 * @param {Function} props.onRegistrationLink - Abre o link de cadastro para o paciente preencher
 * @param {boolean} props.registrationLinkLocked - Plano não inclui o link (mostra o cadeado)
 */
function PageHeader({ onNewPatient, onRegistrationLink, registrationLinkLocked }) {
  return (
    <Box sx={{ mb: 3 }}>
      {/* Title row */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.5rem', md: '1.75rem' },
              color: 'text.primary',
              lineHeight: 1.2,
              mb: 0.5,
            }}
          >
            Pacientes
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontSize: '0.9rem' }}
          >
            Gerencie e acompanhe os pacientes da sua clínica
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <Tooltip
            title={
              registrationLinkLocked
                ? `O link de cadastro ${planAvailabilityText(PROFESSIONAL_PLAN_NAME)}.`
                : ''
            }
            arrow
          >
            <Button
              variant="outlined"
              color="secondary"
              startIcon={registrationLinkLocked ? <LockOutlinedIcon /> : <LinkIcon />}
              onClick={onRegistrationLink}
              sx={registrationLinkLocked ? { opacity: 0.75 } : undefined}
            >
              Gerar link de cadastro
            </Button>
          </Tooltip>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
            onClick={onNewPatient}
            disableElevation
            data-tour="patients-new"
          >
            Novo paciente
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default PageHeader;
